import React from 'react';
import HoverTooltip from './HoverTooltip';

const Tooltip = ({ title, style, hint, isSmall }) => {
  const icon = () => {
    if (style == 'info') { return 'zmdi zmdi-info'; }
    return 'zmdi zmdi-pin-help';
  };

  const hintDesc = () => {
    if (hint == undefined) { return ''; }
    if (isSmall) { return <small> {hint} </small>; }
    return hint;
  };

  return (
    <span className="tooltip-react">
      <HoverTooltip title={title}>
        <a>
          <i className={icon()}></i> {hintDesc()}
        </a>
      </HoverTooltip>
    </span>
  );
};

export default Tooltip;
